export const arrayEqual = <T extends string>(arr1: T[], arr2: T[]): boolean => {
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
};
